{
  "title": "Tidal Wave",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (a drop of water)",
  "duration": "Instantaneous",
  "description": [
    "You conjure up a wave of water that crashes down on an area within range. The area can be up to 30 feet long, up to 10 feet wide, and up to 10 feet tall. Each creature in that area must make a Dexterity saving throw. On a failure, a creature takes 4d8 bludgeoning damage and is knocked prone. On a success, a creature takes half as much damage and isn’t knocked prone. The water then spreads out across the ground in all directions, extinguishing unprotected flames in its area and within 30 feet of it."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
